export default {"src":"/_next/static/media/arbitrum-color.cad3f02b.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};